import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=ffcf861c&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=ffcf861c&prod&scoped=true&lang=css"
import style1 from "./NavButton.vue?vue&type=style&index=1&id=ffcf861c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcf861c",
  null
  
)

export default component.exports